<ui-page-container size="medium">
  <mat-card>
    <mat-card-title>
      <p class="card-inner-title">
        {{ (entityId ? 'Modifica oggetto artistico' : 'Aggiungi oggetto artistico') | translate }}
        <span *ngIf="entityForm?.value?.SGT?.SGTT">
          : {{ entityForm?.value?.SGT?.SGTT }}
          <span *ngIf="entityForm?.value?.numeroEsemplare">
            - {{ entityForm?.value?.numeroEsemplare }}
          </span>
        </span>
      </p>
      <span
        *ngIf="isChildCard$ | async"
        class="badge">
        {{ 'Scheda figlia' }}
      </span>
      <span
        *ngIf="isOperaMadre$ | async"
        class="badge">
        {{ 'Scheda madre' }}
      </span>
      <div
        class="alert-role"
        *roleVisibility="['create', 'update']; classNames: ['BeneOA']; behaviour: 'show'">
        <p>
          {{ 'Il tuo ruolo ti permette solamente di visualizzare le informazioni relative all\'oggetto artistico.' | translate }}
        </p>
        <p>
          {{ 'Nessuna azione di modifica avrà effetto.' | translate }}
        </p>
      </div>
    </mat-card-title>
    <mat-card-content
      class="card-container"
      [class.add]="!entityId">
      <aside>
        <img
          *ngIf="imageUrl; else imagePlaceholder"
          loading="lazy"
          [src]="imageUrl"
          (click)="showMediaHandler()">

        <ng-template #imagePlaceholder>
          <img
            class="card-image-placeholder"
            loading="lazy"
            src="./assets/images/card-placeholder.png"
            (click)="tabChangeHandler({ index: 4 })">
        </ng-template>
        <div class="card-general-actions">
          <button *ngIf="originalImageDownloadUrl"
                  mat-stroked-button
                  color="primary"
                  class="card-download-btn"
                  type="button"
                  (click)="downloadOriginalImage()">
            Scarica immagine originale
          </button>
          <app-card-actions
            *ngIf="entityId"
            cardType="oa"
            className="BeneOA"
            [entity]="entityForm?.value"
            [entityId]="entityId"
            [cardName]="entityForm?.value?.codiceUnico"
            (changeStatus)="changeStatusHandler($event)">
          </app-card-actions>
        </div>
      </aside>

      <form
        *ngIf="entityForm"
        [formGroup]="entityForm"
        (ngSubmit)="dispatchAction(entityForm)">
        <div class="direct-nav-group">
          <button *ngIf="entityForm?.value?.benePadre"
                  color="link"
                  class="card-submit-btn"
                  mat-raised-button
                  (click)="$event.preventDefault()"
                  [routerLink]="['/cards/oa/manager',entityForm?.value?.benePadre]">

            {{ 'Vai alla visualizzazione dell\'opera madre' | translate }}

          </button>

          <button
            *ngIf="entityId"
            color="link"
            class="card-submit-btn"
            mat-raised-button
            #collectionsTrigger="matMenuTrigger"
            [matMenuTriggerFor]="collectionsMenu"
            [disabled]="collections.length === 0 || collectionsLoading"
            (click)="$event.preventDefault()"
            (mouseenter)="collections.length > 0 && !collectionsLoading && collectionsTrigger.openMenu()">

            <mat-spinner 
              *ngIf="collectionsLoading" 
              diameter="20" 
              style="display: inline-block; margin-right: 8px;">
            </mat-spinner>
            <span *ngIf="collectionsLoading">{{ 'Caricamento collezioni...' | translate }}</span>
            <span *ngIf="!collectionsLoading && collections.length > 0">{{ 'Collezioni' | translate }}</span>
            <span *ngIf="!collectionsLoading && collections.length === 0">{{ 'Nessuna collezione' | translate }}</span>

          </button>

          <mat-menu #collectionsMenu="matMenu">
            <button 
              mat-menu-item 
              *ngFor="let collection of collections"
              (click)="navigateToCollection(collection.id)">
              {{ collection.titolo }}
            </button>
          </mat-menu>

          <button
            color="link"
            class="card-submit-btn"
            mat-raised-button
            [routerLink]="['/cards/']">

            {{ 'Oggetti artistici' | translate }}

          </button>

          <button
            color="link"
            class="card-submit-btn"
            mat-raised-button
            [routerLink]="['/cards/']"
            [queryParams]="{ card: '1'}">

            {{ 'Stampe' | translate }}

          </button>

          <button
            color="link"
            class="card-submit-btn"
            mat-raised-button
            [routerLink]="['/cards/']"
            [queryParams]="{ card: '4'}">

            {{ 'Disegni' | translate }}

          </button>
        </div>

        <div class="save-button-container" style="display:flex; align-items: center; justify-content: end;">
          <mat-hint *ngIf="!entityForm.valid" style="color:red;margin-right:5px;">
            ci sono campi obbligatori non compilati {{ findInvalidControlsNames(entityForm) }}
          </mat-hint>
          <button
            *roleVisibility="['create', 'update']; classNames: ['BeneOA']"
            class="card-submit-btn"
            type="submit"
            color="primary"
            mat-raised-button
            [disabled]="!entityForm.valid">
            {{ (entityId ? 'Salva' : 'Crea') | translate }}
          </button>

        </div>

        <mat-tab-group
          animationDuration="0ms"
          [@.disabled]="true"
          [selectedIndex]="activeTabIndex"
          (selectedTabChange)="tabChangeHandler($event)">
          <mat-tab [label]="'ICCD' | translate">
            <app-iccd-manager
              [form]="entityForm"
              [isOperaMadre]="isOperaMadre$ | async"
              [classNames]="['BeneOA']">
            </app-iccd-manager>
          </mat-tab>
          <mat-tab [label]="'Informazioni generali' | translate">
            <app-info-card-manager
              [form]="entityForm"
              [cardId]="entityId"
              [isOperaMadre]="isOperaMadre$ | async"
              [classNames]="['BeneOA']">
            </app-info-card-manager>
          </mat-tab>
          <mat-tab
            *ngIf="isOperaMadre$ | async"
            [label]="'Schede figlie' | translate">
            <app-children-cards-manager
              [card]="entityForm.value"
              [cardId]="entityId"
              (childAdded)="reloadPage()"
              *ngIf="activatedTabs[2]"></app-children-cards-manager>
          </mat-tab>
          <mat-tab [label]="'Fonti bibliografiche' | translate">
            <app-source-bib-manager
              *ngIf="activatedTabs[3]"
              [cardId]="entityId"
              [form]="entityForm.get('fontiBib')"
              [spinner]="spinner"
              [classNames]="['BeneOA']">
            </app-source-bib-manager>
          </mat-tab>
          <mat-tab [label]="'Fonti archivistiche' | translate">
            <app-source-arc-manager
              *ngIf="activatedTabs[4]"
              [cardId]="entityId"
              [form]="entityForm.get('fontiArc')"
              [classNames]="['BeneOA']">
            </app-source-arc-manager>
          </mat-tab>
          <mat-tab [label]="'Allegati' | translate">
            <app-attachments-manager
              *ngIf="activatedTabs[5]"
              [form]="entityForm.get('allegati')"
              [classNames]="['BeneOA']">
            </app-attachments-manager>
          </mat-tab>
          <mat-tab [label]="'Movimenti' | translate">
            <app-movementss-manager
              [form]="entityForm.get('movimenti')"
              [classNames]="['BeneOA']">
            </app-movementss-manager>
          </mat-tab>
          <mat-tab [label]="'Restauri' | translate">
            <app-restorations-manager
              [form]="entityForm.get('restauri')"
              [classNames]="['BeneOA']">
            </app-restorations-manager>
          </mat-tab>
          <mat-tab [label]="'Relazioni' | translate">
            <app-relations-manager
              *ngIf="activatedTabs[8]"
              [cardId]="entityId"
              [form]="entityForm"
              [classNames]="['BeneOA']">
            </app-relations-manager>
          </mat-tab>
        </mat-tab-group>
      </form>
    </mat-card-content>
  </mat-card>
</ui-page-container>
